import { render, staticRenderFns } from "./LaborResolveContractorForm.vue?vue&type=template&id=1937a991&scoped=true&"
import script from "./LaborResolveContractorForm.vue?vue&type=script&lang=ts&"
export * from "./LaborResolveContractorForm.vue?vue&type=script&lang=ts&"
import style0 from "./LaborResolveContractorForm.vue?vue&type=style&index=0&id=1937a991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937a991",
  null
  
)

export default component.exports